import { useCallback, Dispatch } from "react";
import { deleteBankAccount } from "../../../../../../../../acions/customers/bankAccounts";
import { useAppDispatch } from "../../../../../../../../store";

export const useDeleteHandler = () => {
  const dispatch = useAppDispatch();

  const onRemoveClicked = useCallback(
    async (
      id: string,
      disableFunc: Dispatch<React.SetStateAction<boolean>>,
      reload: () => void,
    ) => {
      try {
        disableFunc(true);

        await Promise.resolve(dispatch(deleteBankAccount(id)));
        disableFunc(false);
        reload();
      } catch {
        disableFunc(false);
      }
    },
    [dispatch],
  );

  return { onRemoveClicked };
};
